import { render } from "./SalonMetaData.vue?vue&type=template&id=723cd32e"
import script from "./SalonMetaData.vue?vue&type=script&lang=js"
export * from "./SalonMetaData.vue?vue&type=script&lang=js"

import "./SalonMetaData.vue?vue&type=style&index=0&id=723cd32e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__